/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Bank identifier slug
 * @export
 * @enum {string}
 */

export const BankSlug = {
    mufg: 'mufg',
    netbk: 'netbk',
    paypay: 'paypay',
    gmoAozora: 'gmo-aozora',
    smbc: 'smbc',
    mizuhoEbiz: 'mizuho-ebiz',
    mizuhoBizweb: 'mizuho-bizweb',
    resona: 'resona',
    saitamaresona: 'saitamaresona',
    kansaimirai: 'kansaimirai',
    minatobk: 'minatobk'
} as const;

export type BankSlug = typeof BankSlug[keyof typeof BankSlug];



